var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconAvax = function SvgIconAvax(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5 13c0 7.057-5.596 12.778-12.5 12.778S.5 20.057.5 13 6.096.222 13 .222 25.5 5.943 25.5 13ZM9.458 18.085H7.032c-.51 0-.762 0-.915-.1a.633.633 0 0 1-.28-.493c-.009-.186.117-.412.369-.864l5.99-10.792c.255-.458.384-.688.546-.772a.606.606 0 0 1 .56 0c.162.084.291.314.546.772l1.231 2.197.006.011c.276.492.415.741.476 1.003.068.286.068.587 0 .873-.061.263-.2.514-.479 1.014l-3.146 5.685-.008.015c-.277.495-.418.747-.612.936a1.823 1.823 0 0 1-.747.443c-.254.072-.54.072-1.111.072Zm6.126 0h3.476c.513 0 .77 0 .925-.104a.631.631 0 0 0 .279-.496c.009-.179-.114-.396-.356-.822a5.419 5.419 0 0 1-.025-.044l-1.741-3.045-.02-.034c-.244-.423-.368-.637-.527-.72a.6.6 0 0 0-.555 0c-.16.086-.29.308-.544.757l-1.735 3.045-.006.01c-.254.449-.38.673-.372.856.013.201.114.387.28.497.15.1.408.1.921.1Z",
    fill: "#F44"
  })));
};

export default SvgIconAvax;